import EditInfo from './container';

export default EditInfo;
